export interface BBLDocumentQueryModel {
  take: number
  skip: number
  searchText?: string
  sortColumn?: string
  standardDocument?: boolean
  documentTypeId?: string
  startDate?: string
  endDate?: string
  standard?: boolean
  mimeTypes?: string[]
  sharedWithBbl?: BoardDocumentFilterSharedWithBblEnum
}

export interface BoardDocumentQueryModel {
  take: number
  skip: number
  searchText?: string
  sortColumn?: string
  standardDocument?: boolean
  documentTypeId?: string
  updatedFrom?: string
  updatedTo?: string
  standard?: boolean
  mimeTypes?: string[]
  sharedWithBbl?: BoardDocumentFilterSharedWithBblEnum
}

export enum BoardDocumentFilterSharedWithBblEnum {
  Unfiltered = 'Unfiltered',
  ShowOnlyShared = 'ShowOnlyShared',
}
